module.exports = __webpack_public_path__ + "static/insultech-office-map-97632283b19e150e741c8bb83f6886b5.jpg";